import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Typography,
  message,
  Switch,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEmailConfiguration, loadEmailConfig } from "../../../redux/rtk/features/masters/masterSlice";

const { Title } = Typography;

const EmailConfiguration = ({ selectedCompanyID }) => {
  // console.log("selectedCompanyID", selectedCompanyID);
  
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isTestButtonEnabled, setIsTestButtonEnabled] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [to, setTo] = useState("");
  const dispatch = useDispatch();

  // Fetch email configuration data on component mount or when selectedCompanyID changes
  useEffect(() => {
    if (selectedCompanyID) {
      dispatch(loadEmailConfig(selectedCompanyID));
    }
  }, [dispatch, selectedCompanyID]);

  // Select email configuration data from Redux
  const list = useSelector((state) => state?.masters?.emailConfig) || [];

  // Prefill form fields when `list` is updated
  useEffect(() => {
    if (list && Object.keys(list).length > 0) {
      form.setFieldsValue({
        EmailId: list.EmailId,
        EmailPassword: list.EmailPassword,
        SmtpServer: list.SmtpServer,
        SmtpPort: list.SmtpPort,
        SmtpTls: list.SmtpTls || false,
        ImapServer: list.ImapServer,
        ImapPort: list.ImapPort,
        ImapSsl: list.ImapSsl || false,
      });
      setIsTestButtonEnabled(true); // Enable the test email button
    }
  }, [list, form]);

  const handleFormSubmit = (values) => {
    setLoader(true);

    // Prepare data in the format expected by the API
    const configData = {
      ...values,
      CompanyId: selectedCompanyID, // Include CompanyId
      DataStatus: 1, // Including the DataStatus field required by the API
    };

    dispatch(addEmailConfiguration(configData))
      .then(() => {
        setLoader(false);
        message.success("Configuration saved successfully!");
        setIsTestButtonEnabled(true);
      })
      .catch(() => {
        setLoader(false);
        message.error("Failed to save configuration.");
      });
  };

  const handleTestEmail = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    // if (to) {
    //   dispatch(sendTestEmail({ to, companyId: selectedCompanyID }))
    //     .then(() => {
    //       message.success("Test email sent successfully!");
    //       setIsModalVisible(false);
    //     })
    //     .catch(() => {
    //       message.error("Failed to send test email.");
    //     });
    // } else {
    //   message.error("Please enter a recipient email!");
    // }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setTo("");
  };

  const handleToMailChange = (e) => {
    setTo(e.target.value);
  };

  return (
    <Fragment>
      <div className="p-4">
        <Title level={4} className="text-center text-xl font-bold mb-4">
          Email Configuration
        </Title>
        <Form
          form={form}
          layout="vertical"
          name="email-configuration-form"
          onFinish={handleFormSubmit}
          className="space-y-2"
          autoComplete="off"
        >
          <Row
            gutter={[12, 12]}
            className="grid grid-cols-1 md:grid-cols-3 gap-3"
          >
            <Col>
              <Form.Item
                label="Email ID"
                name="EmailId"
                rules={[
                  { required: true, message: "Please enter the email ID!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  placeholder="Enter email ID"
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="Password"
                name="EmailPassword"
                rules={[
                  { required: true, message: "Please enter the password!" },
                ]}
              >
                <Input.Password
                  placeholder="Enter password"
                  visibilityToggle={false}
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="SMTP Server"
                name="SmtpServer"
                rules={[{ required: true, message: "Please enter the SMTP server!" }]}
              >
                <Input
                  placeholder="Enter SMTP server"
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="SMTP Port"
                name="SmtpPort"
                rules={[
                  { required: true, message: "Please enter the port number!" },
                ]}
              >
                <InputNumber
                  placeholder="Enter port number"
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="SMTP TLS"
                name="SmtpTls"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="IMAP Server"
                name="ImapServer"
                rules={[{ required: true, message: "Please enter the IMAP server!" }]}
              >
                <Input
                  placeholder="Enter IMAP server"
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="IMAP Port"
                name="ImapPort"
                rules={[
                  { required: true, message: "Please enter the port number!" },
                ]}
              >
                <InputNumber
                  placeholder="Enter port number"
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label="IMAP SSL"
                name="ImapSsl"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loader}
              className="mt-4 bg-blue-500 text-white hover:bg-blue-600 text-sm px-4 py-1"
            >
              Save Email Configuration
            </Button>
            {/* <Button
              type="default"
              onClick={handleTestEmail}
              disabled={!isTestButtonEnabled}
              className="mt-4 ml-2 text-sm px-4 py-1"
            >
              Test Email
            </Button> */}
          </Form.Item>
        </Form>
      </div>
      <Modal
        title="Send Test Email"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        className="rounded-lg"
      >
        <Form layout="vertical">
          <Form.Item
            label="To Email"
            name="to"
            rules={[
              { required: true, message: "Please enter the recipient's email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input
              value={to}
              onChange={handleToMailChange}
              placeholder="Enter recipient email"
              className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
            />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EmailConfiguration;

// import {
//   Button,
//   Card,
//   Col,
//   Form,
//   Input,
//   InputNumber,
//   Modal,
//   Row,
//   Typography,
//   message,
//   Switch,
// } from "antd";
// import React, { Fragment, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { addEmailConfiguration, loadEmailConfig } from "../../../redux/rtk/features/masters/masterSlice";


// const { Title } = Typography;

// const EmailConfiguration = () => {
//   const [form] = Form.useForm();
//   const [loader, setLoader] = useState(false);
//   const [isTestButtonEnabled, setIsTestButtonEnabled] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [to, setTo] = useState("");
//   const dispatch = useDispatch();
  
//   // Fetch email configuration data on component mount
//   useEffect(() => {
//     dispatch(loadEmailConfig());
//   }, [dispatch]);

//   // Select email configuration data from Redux
//   const list = useSelector((state) => state?.masters?.emailConfig) || [];

//   // Prefill form fields when `list` is updated
//   useEffect(() => {
//     if (list && Object.keys(list).length > 0) {
//       form.setFieldsValue({
//         EmailId: list.EmailId,
//         EmailPassword: list.EmailPassword,
//         SmtpServer: list.SmtpServer,
//         SmtpPort: list.SmtpPort,
//         SmtpTls: list.SmtpTls || false,
//         ImapServer: list.ImapServer,
//         ImapPort: list.ImapPort,
//         ImapSsl: list.ImapSsl || false,
//       });
//       setIsTestButtonEnabled(true); // Enable the test email button
//     }
//   }, [list, form]);

//   const handleFormSubmit = (values) => {
//     setLoader(true);
    
//     // Prepare data in the format expected by the API
//     const configData = {
//       ...values,
//       DataStatus: 1, // Including the DataStatus field required by the API
//     };
    
//     dispatch(addEmailConfiguration(configData))
//       .then(() => {
//         setLoader(false);
//         message.success("Configuration saved successfully!");
//         setIsTestButtonEnabled(true);
//       })
//       .catch(() => {
//         setLoader(false);
//         message.error("Failed to save configuration.");
//       });
//   };

//   const handleTestEmail = () => {
//     setIsModalVisible(true);
//   };

//   const handleOk = () => {
//     // if (to) {
//     //   dispatch(sendTestEmail({ to }))
//     //     .then(() => {
//     //       message.success("Test email sent successfully!");
//     //       setIsModalVisible(false);
//     //     })
//     //     .catch(() => {
//     //       message.error("Failed to send test email.");
//     //     });
//     // } else {
//     //   message.error("Please enter a recipient email!");
//     // }
//   };

//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleToMailChange = (e) => {
//     setTo(e.target.value);
//   };

//   return (
//     <Fragment>
//       <Card>
//         <Row justify="center">
//           <Col span={12}>
//             <Title level={3} className="text-center">
//               Email Configuration
//             </Title>
//             <Form
//               form={form}
//               layout="vertical"
//               name="email-configuration-form"
//               onFinish={handleFormSubmit}
//               autoComplete="off"
//             >
//               <Form.Item
//                 label="Email ID"
//                 name="EmailId"
//                 rules={[
//                   { required: true, message: "Please enter the email ID!" },
//                   { type: "email", message: "Please enter a valid email!" },
//                 ]}
//               >
//                 <Input placeholder="Enter email ID" />
//               </Form.Item>

//               <Form.Item
//                 label="Password"
//                 name="EmailPassword"
//                 rules={[
//                   { required: true, message: "Please enter the password!" },
//                 ]}
//               >
//                 <Input.Password placeholder="Enter password" visibilityToggle={false} />
//               </Form.Item>

//               <Form.Item
//                 label="SMTP Server"
//                 name="SmtpServer"
//                 rules={[{ required: true, message: "Please enter the SMTP server!" }]}
//               >
//                 <Input placeholder="Enter SMTP server" />
//               </Form.Item>

//               <Form.Item
//                 label="SMTP Port"
//                 name="SmtpPort"
//                 rules={[
//                   { required: true, message: "Please enter the port number!" },
//                 ]}
//               >
//                 <InputNumber
//                   placeholder="Enter port number"
//                   style={{ width: "100%" }}
//                 />
//               </Form.Item>
              
//               <Form.Item
//                 label="SMTP TLS"
//                 name="SmtpTls"
//                 valuePropName="checked"
//               >
//                 <Switch />
//               </Form.Item>

//               <Form.Item
//                 label="IMAP Server"
//                 name="ImapServer"
//                 rules={[{ required: true, message: "Please enter the IMAP server!" }]}
//               >
//                 <Input placeholder="Enter IMAP server" />
//               </Form.Item>

//               <Form.Item
//                 label="IMAP Port"
//                 name="ImapPort"
//                 rules={[
//                   { required: true, message: "Please enter the port number!" },
//                 ]}
//               >
//                 <InputNumber
//                   placeholder="Enter port number"
//                   style={{ width: "100%" }}
//                 />
//               </Form.Item>
              
//               <Form.Item
//                 label="IMAP SSL"
//                 name="ImapSsl"
//                 valuePropName="checked"
//               >
//                 <Switch />
//               </Form.Item>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={loader}
//                   block
//                 >
//                   Save
//                 </Button>
//               </Form.Item>

//               {/* <Form.Item>
//                 <Button
//                   type="default"
//                   onClick={handleTestEmail}
//                   disabled={!isTestButtonEnabled}
//                   block
//                 >
//                   Test Email
//                 </Button>
//               </Form.Item> */}
//             </Form>
//           </Col>
//         </Row>
//       </Card>
//       <Modal
//         title="Send Test Email"
//         visible={isModalVisible}
//         onOk={handleOk}
//         onCancel={handleCancel}
//       >
//         <Form>
//           <Form.Item
//             label="To Email"
//             name="to"
//             rules={[
//               { required: true, message: "Please enter the recipient's email!" },
//               { type: "email", message: "Please enter a valid email!" },
//             ]}
//           >
//             <Input
//               value={to}
//               onChange={handleToMailChange}
//               placeholder="Enter recipient email"
//             />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </Fragment>
//   );
// };

// export default EmailConfiguration;